<template>
  <div>
    <Banner />
    <div class="main-content">
      <div class="article-title mb30">{{info.title}}</div>
      <!-- <div class="publish-time">发表时间：2020年7月1日</div> -->
      <div class="article-content" v-html="info.content"></div>
      <div class="article-end" v-if="false">
        <div class="page-btn more-text">
          <span class="prev-page">上一篇</span>
          <a>20200702林业厅到现场了解公司种植，病虫害防治情况</a>
        </div>
        <div class="page-btn next more-text">
          <span class="next-page">下一篇</span>
          <a>20200702林业厅到现场了解公司种植，病虫害防治情况</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from '../../components/Banner'
export default {
  components: {
    Banner
  },
  data() {
    return {
      info: {
        title: '',
        brief: '',
        content: '',
        createTime: ''
      }
    }
  },
  mounted() {
    this.info = this.$route.params
  }
}
</script>

<style scoped lang="scss">
  .article-title {
    text-align: center;
    line-height: 34px;
    font-size: 26px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
  }
  .publish-time {
    height: 30px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 30px;
    color: #999999;
  }
  .article-content {
    line-height: 40px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin: 50px 0;
  }
  .article-end {
    display: flex;
    justify-content: space-between;
    width: 100%;
    line-height: 30px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    .page-btn {
      width: 40%;
      &.next {
        text-align: right;
      }
    }
    .prev-page {
      margin-right: 50px;
    }
    .next-page {
      margin-right: 50px;
    }
  }
  
  .base-info {
    text-align: left;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 40px;
    color: #666666;
  }
</style>